module.exports = __webpack_public_path__ + "static/media/delete.cf5699aa.svg";